import { CaptureResult } from './ExpoMiSnap.types';
import { requireOptionalNativeModule } from 'expo-modules-core';

export interface ExpoMiSnap {
  captureCheck: (side: 'front' | 'back') => Promise<CaptureResult>;
  setLicenseKey: (key: string) => void;
}

// Returns null on builds that lack the native module so we can gracefully
// degrade instead of crashing on bundle load.
export default requireOptionalNativeModule<ExpoMiSnap>('ExpoMiSnap');
